import { PromptInput } from '@atlassian/boysenberry-prompt-input';
import { useState } from 'react';
import { useIntl } from 'react-intl-next';

import messages from './messages';

export const BoysenberryPrompt = () => {
	const [promptValue, setPromptValue] = useState('');
	const { formatMessage } = useIntl();

	return (
		<PromptInput
			value={promptValue}
			placeholder={formatMessage(messages.promptPlaceholder)}
			appearance="compact"
			onChange={setPromptValue}
		/>
	);
};
